var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import { Checkbox as Checkbox$2 } from "@fluentui/react/lib/Checkbox";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import { getId, css } from "@fluentui/utilities";
const Checkbox$1 = "";
const defaultClassName = "ane-Checkbox";
const Checkbox = (props) => {
  const _a = props, { className, isReadOnly, label, id = getId("checkbox-"), checked } = _a, rest = __objRest(_a, ["className", "isReadOnly", "label", "id", "checked"]);
  return !!isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value: !!checked ? "True" : "False" }) : /* @__PURE__ */ jsx(Checkbox$2, __spreadProps(__spreadValues({}, rest), { id, label, className: css(defaultClassName, className), checked }));
};
export {
  Checkbox,
  Checkbox as default
};
//# sourceMappingURL=Checkbox.js.map
